export default "__VITE_ASSET__CD5RL46V__"